// 옵션 이미지를 고칠 상품·옵션 자리 — 등록ID 로 상품을 먼저 고르고 그 안에서 옵션 번호를 찾는다.
// 옛 store 는 옵션 번호만으로 목록의 첫 상품을 골라, 같은 번호를 가진 딴 상품(견적서 분리분 _2 등)의
// 대표이미지를 덮었다. 등록ID 가 없으면 옵션 번호만으로 찾지 않고 던진다.
export function findOptionTarget(products, registrationId, optionNumber) {
  if (registrationId === undefined || registrationId === null || registrationId === '') {
    throw new Error(`옵션 이미지를 고칠 상품의 등록ID 가 없습니다(옵션 ${optionNumber})`)
  }
  const id = String(registrationId)
  const product = (products || []).find(p => p && String(p.registrationId) === id)
  if (!product || !Array.isArray(product.options)) return null
  const optionIndex = product.options.findIndex(opt => opt.optionNumber === optionNumber)
  return optionIndex === -1 ? null : { product, optionIndex }
}
